var map = {
	"./goldcoin/lucky/key.png": 23574,
	"./goldcoin/lucky/light1.png": 14211,
	"./goldcoin/lucky/light2.png": 18605,
	"./goldcoin/lucky/lucky-btn-bg.png": 91533,
	"./goldcoin/lucky/lucky-item-bg.png": 9057,
	"./goldcoin/lucky/lucky-result-coin-tapcoins.png": 8281,
	"./goldcoin/lucky/lucky-result-coin-ton.png": 51,
	"./goldcoin/lucky/lucky-result-coin-usdt.png": 26486,
	"./goldcoin/lucky/lucky-result-light.png": 27732,
	"./goldcoin/lucky/tapcoins.png": 58232,
	"./goldcoin/lucky/ton.png": 26625,
	"./goldcoin/lucky/usdt.png": 35979,
	"./tapcoin/lucky/key.png": 64765,
	"./tapcoin/lucky/light1.png": 94421,
	"./tapcoin/lucky/light2.png": 73133,
	"./tapcoin/lucky/lucky-btn-bg.png": 2548,
	"./tapcoin/lucky/lucky-item-bg.png": 48012,
	"./tapcoin/lucky/lucky-result-coin-tapcoins.png": 16414,
	"./tapcoin/lucky/lucky-result-coin-ton.png": 82649,
	"./tapcoin/lucky/lucky-result-coin-usdt.png": 11104,
	"./tapcoin/lucky/lucky-result-light.png": 60268,
	"./tapcoin/lucky/tapcoins.png": 78565,
	"./tapcoin/lucky/ton.png": 52808,
	"./tapcoin/lucky/usdt.png": 5976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48147;